import { render, staticRenderFns } from "./AttributeTextSelector.vue?vue&type=template&id=10938ced&scoped=true&"
import script from "./AttributeTextSelector.vue?vue&type=script&lang=js&"
export * from "./AttributeTextSelector.vue?vue&type=script&lang=js&"
import style0 from "./AttributeTextSelector.vue?vue&type=style&index=0&id=10938ced&prod&scoped=true&lang=css&"
import style1 from "./AttributeTextSelector.vue?vue&type=style&index=1&id=10938ced&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10938ced",
  null
  
)

export default component.exports